export var actionsTableWrap = {
  marginBottom: '2.5em',
  '& > div': {
    margin: 0
  }
};